<template>
	<div class="midlle" >
		<div class="myProject">
		<div class="title">
			<span class="tit">新建和管理企业</span>
		</div>
		<div style="padding: 30px 15px;box-sizing: border-box;line-height: 24px;color: #888;">
			<p style="text-indent: 2em;">
			    企业实体的功能和要求介绍。企业实体的功能和要求介绍。企业实体的功能和要求介绍。企业实体的功能和要求介绍。企业实体的功能和要求介绍。企业实体的功能和要求介绍。企业实体的功能和要求介绍。企业实体的功能和要求介绍。企业实体的功能和要求介绍。企业实体的功能和要求介绍。企业实体的功能和要求介绍。企业实体的功能和要求介绍。
			</p>
		</div>
		<div class="midlle-body">
			<div class="body-title">
				<div class="line"></div>
				<div style="margin-left: 20px;">已创建的企业</div>
			</div>
			<el-table :data="tableData3" stripe style="width: 100%" border="" @cell-click='cc'>
				<el-table-column prop="id" label="编号" width="50" :resizable="false">
				</el-table-column>
				<el-table-column prop="name" label="企业名称" width="192" :resizable="false">
				  
				</el-table-column>
				<el-table-column label="状态" width="142" :resizable="false">
					<template slot-scope="scope">
						<p v-if="scope.row.status == 1&&scope.row.authentication_data!=3">已认证,正常</p>
						<p style="color: red;" v-if="scope.row.authentication_data==3">驳回</p>
						<p v-if="scope.row.status == 2&&scope.row.authentication_data!=3">暂停</p>
						<p v-if="scope.row.status == 2&&scope.row.authentication_data==3">驳回</p>
						<p v-if="scope.row.status == 3&&scope.row.authentication_data!=3">注销</p>
						<p v-if="scope.row.status == 3&&scope.row.authentication_data!=3">驳回</p>
					</template>
				</el-table-column>
				<el-table-column prop="bhyj" label="驳回意见" width="300" :resizable="false">
				  
				</el-table-column>
				<el-table-column label="管理" width="150" :resizable="false">
					<template slot-scope="scope">
						<div v-if="scope.row.authentication_data==3">
							<p style="cursor: pointer;display: flex;align-items: center;justify-content: center;">
								<span style="margin-right: 6px;" @click="$router.push({ path: `/userCenter/updateCompany?id=${scope.row.id}` })">修改</span>
							</p>
						</div>
						<div v-if="scope.row.status == 1&&scope.row.authentication_data!=3">
							<p style="cursor: pointer;display: flex;align-items: center;justify-content: center;">
								<span style="margin-right: 6px;" @click="changeCompanyStatus(scope.row,'logout')">注销</span>
							<span>|</span><span style="cursor: pointer; margin-left: 6px;color: #0052D9;" @click="changeCompanyStatus(scope.row,'hangup')">挂起</span></p>
						</div>
						<div v-if="scope.row.status == 2&&scope.row.authentication_data!=3">
							<p style="cursor: pointer;display: flex;align-items: center;justify-content: center;">
								<span style="margin-right: 6px;" @click="changeCompanyStatus(scope.row,'logout')">注销</span>
							<span>|</span><span style="cursor: pointer; margin-left: 6px;color: #0052D9;" @click="changeCompanyStatus(scope.row,'cancelHangup')">取消挂起</span></p>
						</div>
						<div v-if="scope.row.status == 3&&scope.row.authentication_data!=3">
							<p style="cursor: pointer;display: flex;align-items: center;justify-content: center;">
								已注销</p>
						</div>
					</template>
				</el-table-column>

		
			</el-table>
			<div class="addCompany" @click="$router.push(`/userCenter/createCompany`)">
				+新建企业
			</div>
		</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				tableData3: [{
					num: 1,
					companyName:'复习科技公司',
					status: 1,
				},
				{
					num: 1,
					companyName:'复习科技公司',
					status: 1,
				},
				{
					num: 1,
					companyName:'复习科技公司',
					status: 1,
				},
				],
			}
		},
		created() {
			this.getCompanyList()
		},
		methods: {
			async getCompanyList(){
				const list = await this.$api.getMyCompanyList({page_size:9999})
				this.tableData3 = list.data.data
			},
			async changeCompanyStatus(item,type){
				let change 
				if(type == 'logout'){
					 change = await this.$api.changeCompanyStatusHandler({id:item.id,status:3})
				}else if(type == 'hangup'){
					change = await this.$api.changeCompanyStatusHandler({id:item.id,status:2})
				}else if(type == 'cancelHangup'){
					change = await this.$api.changeCompanyStatusHandler({id:item.id,status:1})
				}
				if(change.code == 1){
					this.$message({
						message:change.msg,
						type:'success'
					})
					this.getCompanyList()
				}else{
					this.$message({
						message:change.msg,
						type:'warning'
					})
				}
				
			},
			cc(row, column, cell, event) {
				// console.log(row, column.label, cell, event);
			},
		}
	}
</script>

<style lang="less" scoped>
	
	.midlle-body {
		.addCompany{
			width: 261px;
			height: 40px;
			background: #0052D9;
			cursor: pointer;
			margin: auto;
			margin-top: 30px;
			color: white;
			line-height: 40px;
			text-align: center;
		}
		padding-bottom: 10px;
	
		/deep/.link {
			color: #0052D9;
			cursor: pointer;
			display: flex;
			justify-content: space-around;
		}
	
		padding-top: 20px;
		box-sizing: border-box;
		background: white;
		.body-title {
			color: #0052D9;
			display: flex;
			margin-bottom: 20px;
			font-weight: bold;
			font-size: 18px;
		
			.line {
				width: 4px;
				height: 22px;
				background: #0052D9;
			}
		}
		.loading {
			cursor: pointer;
			width: 116px;
			height: 40px;
			background: #F6F6F6;
			display: flex;
			align-items: center;
			margin: 10px;
			margin-bottom: 0;
			justify-content: center;
		}
		
	}
	.midlle{
		.myProject{
			width: 840px;
			padding: 20px 0;
			background: #FFFFFF;
		}
		
		width: 880px;
		    padding: 0 20px;
		    box-sizing: border-box;
			.title{
				display: flex;
				height: 40px;
				background: #E5EDFB;
				align-items: center;
				p{
					font-size: 14px;
					color: black;
					margin-left: 10px;
					span{
						color: #0052D9;
					}
				}
				.tit{
					display: inline-block;
					padding:0 20px ;
					background: #0052D9;
					height: 40px;
					line-height: 40px;
					color: white;
					font-size: 18px;
					border-radius: 0px 20px 20px 0px;
					font-weight: bold;
				}
			}
	}
</style>